import httpClient from "../../../client/httpClient";

// Main categories
export const fetchMainCategories = async (marketType) => {
    try {
        const query = marketType ? `?marketType=${encodeURIComponent(marketType)}` : "";
        const res = await httpClient.get(`v1/api/category/main-category-all${query}`);
        return res.data;
    } catch (error) {
        console.error("Failed to fetch main categories:", error);
        throw error;
    }
};

export const createMainCategory = async (mainCategoryData) => {
    try {
        const res = await httpClient.post("v1/api/category/main-category-create", {}, {
            params: mainCategoryData
        });
        return res.data;
    } catch (error) {
        console.error("Failed to create main category:", error);
        throw error;
    }
};

// Sub categories
export const fetchSubCategories = async (marketType) => {
    try {
        const query = marketType ? `?marketType=${encodeURIComponent(marketType)}` : "";
        const res = await httpClient.get(`v1/api/category/sub-category-all${query}`);
        return res.data;
    } catch (error) {
        console.error("Failed to fetch sub categories:", error);
        throw error;
    }
};

export const createSubCategory = async (subCategoryData) => {
    try {
        const res = await httpClient.post(
            "v1/api/category/sub-category-create",
            {},
            { params: subCategoryData }
        );
        return res.data;
    } catch (error) {
        console.error("Failed to create sub category:", error);
        throw error;
    }
};

// Sub-sub categories
export const fetchSubSubCategories = async (marketType) => {
    try {
        const query = marketType ? `?marketType=${encodeURIComponent(marketType)}` : "";
        const res = await httpClient.get(`v1/api/category/sub-sub-category-all${query}`);
        return res.data;
    } catch (error) {
        console.error("Failed to fetch sub-sub categories:", error);
        throw error;
    }
};

export const createSubSubCategory = async (categoryData) => {
    try {
        const res = await httpClient.post("v1/api/category/sub-sub-category-save", categoryData);
        return res.data;
    } catch (error) {
        console.error("Failed to create sub-sub category:", error);
        throw error;
    }
};

export const updateSubSubCategory = async (categoryId, categoryData) => {
    try {
        const res = await httpClient.put(`v1/api/category/update/${categoryId}`, categoryData);
        return res.data;
    } catch (error) {
        console.error("Failed to update sub-sub category:", error);
        throw error;
    }
};

export const toggleSubSubcategoriestatus = async (categoryId, isActive) => {
    try {
        const res = await httpClient.delete(
            `v1/api/category/make-enable-disable?id=${categoryId}&enable=${isActive}`
        );
        return res.data;
    } catch (error) {
        console.error("Failed to toggle sub-sub category status:", error);
        throw error;
    }
};
